import baseApi from "./baseApi"

export default  {
    /**
     * Fetch User Alerts from Server who matches token.
     * @return {Object} -- Alert Totals
     */
    async getAlertTotals() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/alerts/totals");
        
        return result.data;
    },
    /**
     * Fetch User Alert Categories from Server who matches token.
     * @return {Object} -- Alert Totals
     */
    async getCategories() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/alerts/categories");
        
        return result.data;
    },
     /**
     * Fetch User alerts from Server who matches token.
     * @return {Object} -- Alerts
     */
    async getAlerts(max) {
        let url = "/alerts";

        if(max) {
            url += "?max=" + max
        }

        let request = await baseApi.createHttpRequest();
        let result = await request.get(url);

        return result.data;
    }
}